import { render, staticRenderFns } from "./GridMatchPage.vue?vue&type=template&id=de571074&scoped=true&"
import script from "./GridMatchPage.vue?vue&type=script&lang=js&"
export * from "./GridMatchPage.vue?vue&type=script&lang=js&"
import style0 from "./GridMatchPage.vue?vue&type=style&index=0&id=de571074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de571074",
  null
  
)

export default component.exports